"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedItemGrid = void 0;
const EventDto_1 = require("../dto/EventDto");
class FeedItemGrid {
    constructor() {
        this.id = 0;
        this.dateTime = "";
        this.title = "string";
        this.status = "";
    }
    static from(feedItem, draft, dateTime) {
        const result = new FeedItemGrid();
        result.id = feedItem.id;
        result.dateTime = dateTime;
        result.title = feedItem.title;
        result.status = feedItem.status === EventDto_1.FeedItemStatusDto.DRAFT ? draft : "";
        return result;
    }
    static visibleFields() {
        return ["dateTime", "title", "status"];
    }
}
exports.FeedItemGrid = FeedItemGrid;
